import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'
import messages from '@/utils/messages'
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'
import { EnumButtonSizes, EnumRouteNames }	from '@/enums/enums';
import { useRouter }						from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'BtnDiscardChanges',
  setup(__props) {

const router = useRouter();
const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()

const onDiscardChangesBtnClick = async () => {
  try {
    pagesUtilStore.showLoading = true

    const id = institutionalStore.institutionalDetail?.id
    if (!id) return

    await institutionalStore.discardChanges(id)

    messages.showSuccessMsg("Alterações descartadas com sucesso!")

    
  // ✅ REDIRECIONA PRA LISTAGEM
    router.push({
      name: EnumRouteNames.INSTITUTIONAL_SEARCH
    })


  } catch (error) {
    messages.showErrorMsg("Erro ao tentar descartar alterações...")

  } finally {
    pagesUtilStore.showLoading = false
  }
}



return (_ctx: any,_cache: any) => {
  const _component_c_q_btn = _resolveComponent("c-q-btn")!

  return (_unref(authStore).currentUserCanCancelInstitutional
    && (_unref(institutionalStore).institutionalDetail?.status == _unref(CONST_INSTITUTIONAL_STATUS).ADJUSTMENT_REQUESTED_AGAIN.id
      || _unref(institutionalStore).institutionalDetail?.status == _unref(CONST_INSTITUTIONAL_STATUS).ON_REISSUE.id
      || _unref(institutionalStore).institutionalDetail?.status == _unref(CONST_INSTITUTIONAL_STATUS).REAPPROVED.id))
    ? (_openBlock(), _createBlock(_component_c_q_btn, {
        key: 0,
        id: "btn-discard-changes",
        propBtnLabel: "Descartar Alterações",
        propBtnFunction: onDiscardChangesBtnClick,
        propBtnTransparent: true,
        propBtnSize: _unref(EnumButtonSizes).LARGE_1
      }, null, 8, ["propBtnSize"]))
    : _createCommentVNode("", true)
}
}

})